(function($) {
	"use strict";

    var social = {};

    /*
    * On init.
    */
    social.init = function(){


        // Load our posts (All)
        social.loadPosts( -1 );
    }

    /**
     *  Click inside filter.
     */
    $('#socialmedia').on('click','.filter .btn', function(){
        var terms = false;

        // Set/unset selected class.
        $(this).toggleClass( 'selected' );

        // If all is selected, unselected all other.
        if( $(this).data('term-id') == '-1' ){
            $( '#socialmedia .btn.selected').removeClass('selected');
            $( '#socialmedia .btn.all').addClass('selected');
        }
        // Remove selected class from All when another filter is selected.
        else if( $(this).data('term-id') != '-1' ){
            $( '#socialmedia .btn.all').removeClass('selected');
        }
        // If no filter is selected set all as selected.
        if( ( $( '#socialmedia .btn.selected') ).length == 0 ) {
            $( '#socialmedia .btn.all').addClass( 'selected' );
        }

        // Get all selected terms.
        $.each( $('#socialmedia .filter .selected') , function( index, value ) {
            if( ! terms ){
                terms = $(this).data('term-id');
            }
            else {
                terms = terms + ',' + $(this).data('term-id');
            }
        });


         social.loadPosts( terms );

         return false;
    });



    /**
     *    Loads our posts.
     */
    social.loadPosts = function( terms ){
        // Add a loader.
        social.addLoader( $('#socialmedia .posts') );

        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            dataType: 'html',
            cache: false,
            data: {
                action: 'get_socialmedia_posts',
                nonce: ajax_object.ajax_nonce,
                terms: terms,
            },
            success: function( result ) {
                $("#socialmedia .posts").html( result );
            },
            error: function(result){
                $("#socialmedia .posts").html( '<p>Ett fel uppstod när formuläret skulle laddas!</p>' );
            }
        });

    }

    /**
     *    Adds a looader.
     */
    social.addLoader = function( element ){
        $( element ).html('<div class="card" style="border:0;"></div><div class="sk-circle black"><div class="sk-circle1 sk-child"></div><div class="sk-circle2 sk-child"></div><div class="sk-circle3 sk-child"></div><div class="sk-circle4 sk-child"></div><div class="sk-circle5 sk-child"></div><div class="sk-circle6 sk-child"></div><div class="sk-circle7 sk-child"></div><div class="sk-circle8 sk-child"></div><div class="sk-circle9 sk-child"></div><div class="sk-circle10 sk-child"></div><div class="sk-circle11 sk-child"></div><div class="sk-circle12 sk-child"></div></div>');
    }

	$(document).ready(function() {
        // Init functions.
        social.init();
    });


})( jQuery );
